import { badgeLabelsComponent } from './badgeLabelsComponent';
import { pdpSpecificVideoLockupComponent } from './pdpSpecificVideoLockupComponent';
import { twPaginationComponent } from './twPaginationComponent';

export const tailwind = {
  badgeLabelsComponent,
  pdpSpecificVideoLockupComponent,
  twPaginationComponent,
};
